import { createStore } from "vuex";
import onboarding from "./modules/onboarding.js";
import getStarted from "./modules/getStarted.js";
import calls from "./modules/calls.js";
import callLogs from "@/src/store/modules/callLogs.js";
import callsCampaign from "@/src/store/modules/callsCampaign.js";
import conferenceCall from "@/src/store/modules/conferenceCall.js";
import analytics from "@/src/store/modules/analytics.js";
import analyticsConfiguration from "@/src/store/modules/analyticsConfiguration.js";
import dynamicBanner from "@/src/store/modules/dynamicBanner.js";
import tasks from "@/src/store/modules/tasks.js";
import auth from "@/src/store/modules/auth.js";
import pagination from "@/src/store/modules/pagination.js";
import dialerSettings from "@/src/store/modules/dialerSettings.js";
import rbac from "@/src/store/modules/rbac.js";
import theme from "@/src/store/modules/theme.js";
import billing from "@/src/store/modules/billing.js";
import workspace from "@/src/store/modules/workspace.js";
import meetings from "@/src/store/modules/meetings.js";
import telephony from "@/src/store/modules/telephony.js";
import inboundAgent from "@/src/store/modules/inboundAgent.js";
import users from "@/src/store/modules/users.js";
import appStore from "@/src/store/modules/appStore.js";
import spaces from "@/src/store/modules/spaces.js";
import projects from "@/src/store/modules/projects.js";
import voiceAgents from "@/src/store/modules/voiceAgents.js";
import schema from "@/src/store/modules/schema.js";
import views from "@/src/store/modules/views.js";
import pipelines from "@/src/store/modules/pipelines.js";
import kanban from "@/src/store/modules/kanban.js";
import dashboard from "@/src/store/modules/dashboard.js";
import whatsappCampaign from "@/src/store/modules/whatsappCampaign.js";
import objects from "@/src/store/modules/objects.js";
import chats from "@/src/store/modules/chats.js";
import huddles from "@/src/store/modules/huddles.js";
import quickActions from "@/src/store/modules/quickActions.js";
import prDetail from "@/src/store/modules/prDetail.js";
import codebase from "@/src/store/modules/codebase.js";
import codeActions from "@/src/store/modules/codeActions.js";
import embeddedChats from "@/src/store/modules/embeddedChats.js";

export default createStore({
  modules: {
    auth,
    onboarding,
    getStarted,
    calls,
    callLogs,
    callsCampaign,
    conferenceCall,
    analytics,
    analyticsConfiguration,
    dynamicBanner,
    tasks,
    pagination,
    dialerSettings,
    rbac,
    theme,
    billing,
    workspace,
    meetings,
    telephony,
    inboundAgent,
    users,
    appStore,
    spaces,
    projects,
    voiceAgents,
    schema,
    views,
    pipelines,
    kanban,
    dashboard,
    whatsappCampaign,
    objects,
    chats,
    huddles,
    quickActions,
    prDetail,
    codebase,
    codeActions,
    embeddedChats,
  },
  state: {
    paymentStatus: null,
    showLowCreditsMessage: false,
  },
  mutations: {
    SET_PAYMENT_STATUS: (state, status) => {
      state.paymentStatus = status;
    },
    SET_SHOW_LOW_CREDITS_MESSAGE: (state, status) => {
      state.showLowCreditsMessage = status;
    },
  },
  actions: {
    setPaymentStatus({ commit }, paymentStatus) {
      commit("SET_PAYMENT_STATUS", paymentStatus);
    },
    setShowLowCreditsMessage({ commit }, showLowCreditsMessage) {
      commit("SET_SHOW_LOW_CREDITS_MESSAGE", showLowCreditsMessage);
    },
  },
  getters: {
    getPaymentStatus: (state) => state.paymentStatus,
    getShowLowCreditsMessage: (state) => state.showLowCreditsMessage,
  },
});
